export default {"src":"/_next/static/media/earth solution logo.86164be8.svg","height":61,"width":144,"blurWidth":0,"blurHeight":0};